module.exports = __webpack_public_path__ + "img/big-quote.d8782cd0.svg";